"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmwareUpdateStatusResponseT = exports.FirmwareUpdateStatusResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const firmware_update_device_id_js_1 = require("../../solarxr-protocol/rpc/firmware-update-device-id.js");
const firmware_update_status_js_1 = require("../../solarxr-protocol/rpc/firmware-update-status.js");
class FirmwareUpdateStatusResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsFirmwareUpdateStatusResponse(bb, obj) {
        return (obj || new FirmwareUpdateStatusResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsFirmwareUpdateStatusResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new FirmwareUpdateStatusResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    deviceIdType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : firmware_update_device_id_js_1.FirmwareUpdateDeviceId.NONE;
    }
    deviceId(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
    }
    status() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : firmware_update_status_js_1.FirmwareUpdateStatus.DOWNLOADING;
    }
    /**
     * from 0 to 100
     */
    progress() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 0;
    }
    static startFirmwareUpdateStatusResponse(builder) {
        builder.startObject(4);
    }
    static addDeviceIdType(builder, deviceIdType) {
        builder.addFieldInt8(0, deviceIdType, firmware_update_device_id_js_1.FirmwareUpdateDeviceId.NONE);
    }
    static addDeviceId(builder, deviceIdOffset) {
        builder.addFieldOffset(1, deviceIdOffset, 0);
    }
    static addStatus(builder, status) {
        builder.addFieldInt8(2, status, firmware_update_status_js_1.FirmwareUpdateStatus.DOWNLOADING);
    }
    static addProgress(builder, progress) {
        builder.addFieldInt8(3, progress, 0);
    }
    static endFirmwareUpdateStatusResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createFirmwareUpdateStatusResponse(builder, deviceIdType, deviceIdOffset, status, progress) {
        FirmwareUpdateStatusResponse.startFirmwareUpdateStatusResponse(builder);
        FirmwareUpdateStatusResponse.addDeviceIdType(builder, deviceIdType);
        FirmwareUpdateStatusResponse.addDeviceId(builder, deviceIdOffset);
        FirmwareUpdateStatusResponse.addStatus(builder, status);
        FirmwareUpdateStatusResponse.addProgress(builder, progress);
        return FirmwareUpdateStatusResponse.endFirmwareUpdateStatusResponse(builder);
    }
    unpack() {
        return new FirmwareUpdateStatusResponseT(this.deviceIdType(), (() => {
            const temp = (0, firmware_update_device_id_js_1.unionToFirmwareUpdateDeviceId)(this.deviceIdType(), this.deviceId.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })(), this.status(), this.progress());
    }
    unpackTo(_o) {
        _o.deviceIdType = this.deviceIdType();
        _o.deviceId = (() => {
            const temp = (0, firmware_update_device_id_js_1.unionToFirmwareUpdateDeviceId)(this.deviceIdType(), this.deviceId.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })();
        _o.status = this.status();
        _o.progress = this.progress();
    }
}
exports.FirmwareUpdateStatusResponse = FirmwareUpdateStatusResponse;
class FirmwareUpdateStatusResponseT {
    constructor(deviceIdType = firmware_update_device_id_js_1.FirmwareUpdateDeviceId.NONE, deviceId = null, status = firmware_update_status_js_1.FirmwareUpdateStatus.DOWNLOADING, progress = 0) {
        this.deviceIdType = deviceIdType;
        this.deviceId = deviceId;
        this.status = status;
        this.progress = progress;
    }
    pack(builder) {
        const deviceId = builder.createObjectOffset(this.deviceId);
        return FirmwareUpdateStatusResponse.createFirmwareUpdateStatusResponse(builder, this.deviceIdType, deviceId, this.status, this.progress);
    }
}
exports.FirmwareUpdateStatusResponseT = FirmwareUpdateStatusResponseT;
